import AuthClient from "./src/AuthClient";
import { validateCrypto } from "./src/utils";

export default async function createAuthClient(options) {
    validateCrypto();
    return new AuthClient(options);
}
